import { Set } from 'immutable';

import { MAX_NUMBER_OF_FILES, MAX_NUMBER_OF_VIDEOS } from './validations';
import { ETSY, SHOPIFY } from './channels';
import { ERROR, NEW } from './product';
import ATTRIBUTE from './attributes';

export const THUMBNAIL_SIZE = 120;
export const THUMBNAIL_GAP = 12;

export const PHOTOS_TO_DISPLAY = 10;

export const FILES_TO_DISPLAY = {
  [ETSY]: MAX_NUMBER_OF_FILES[ETSY],
};

export const VIDEOS_TO_DISPLAY = {
  [ETSY]: MAX_NUMBER_OF_VIDEOS[ETSY],
  [SHOPIFY]: 8,
};

export const MESSAGES = {
  CUSTOM_SHIPPING_OPTIONS: 'Custom shipping options',
  DEFINED_BY_VARIATION: 'Defined by Variation',
  INSTRUCTIONS: 'Example: Enter the name you want on the necklace. Max 12 characters, no\nspaces, no special characters. Thank you!',
  NOT_AVAILABLE: 'Not available',
  NOT_SUPPORTED: 'Not supported',
  NO_RESULTS_FOUND: 'No results found',
  PUBLISH_PROHIBITED: 'prohibited this listing from being published',
  REFRESH_SHOP_FOR_PERSONALIZATION: 'Click "Refresh shop" to import your personalizations from Etsy and edit them in Vela',
  UPLOAD_NOT_SUPPORTED: 'Digital files cannot be included for "Made to Order" listings. Upload files after purchase to complete the order.',
  WHEN_YOU_MADE_IT: 'When did you make it?',
};

export const PLACEHOLDERS = {
  [ATTRIBUTE.ALT_TEXT]: 'Alt text',
  [ATTRIBUTE.BARCODE]: 'Barcode',
  [ATTRIBUTE.CAP]: 'CAP',
  [ATTRIBUTE.CATEGORY]: 'Choose Category',
  [ATTRIBUTE.CHAR_COUNT_MAX]: 'Limit',
  [ATTRIBUTE.COLLECTIONS]: 'Choose Collections',
  [ATTRIBUTE.COUNTRY_CODE]: 'Choose country/region',
  [ATTRIBUTE.CPI]: 'CPI',
  [ATTRIBUTE.DESCRIPTION]: 'Description',
  [ATTRIBUTE.HEIGHT]: 'Height',
  [ATTRIBUTE.HS_CODE]: 'HS Code',
  [ATTRIBUTE.INSTRUCTIONS]: 'Instructions',
  [ATTRIBUTE.IS_SUPPLY]: 'What is it?',
  [ATTRIBUTE.LENGTH]: 'Length',
  [ATTRIBUTE.PAGE_TITLE]: 'Page title',
  [ATTRIBUTE.MATERIALS]: 'Materials',
  [ATTRIBUTE.PRICE]: 'Price',
  [ATTRIBUTE.PRODUCTION_PARTNERS]: 'Choose Production partner',
  [ATTRIBUTE.PRODUCT_TYPE]: 'Choose Product type',
  [ATTRIBUTE.PROFILE_ID]: 'Choose Shipping profile',
  [ATTRIBUTE.RETURN_POLICY]: 'Choose Return policy',
  [ATTRIBUTE.QUANTITY]: 'Quantity',
  [ATTRIBUTE.SECTION]: 'Choose Section',
  [ATTRIBUTE.SKU]: 'SKU',
  [ATTRIBUTE.TAGS]: 'Tags',
  [ATTRIBUTE.TITLE]: 'Title',
  [ATTRIBUTE.VENDOR]: 'Choose Vendor',
  [ATTRIBUTE.WEIGHT]: 'Weight',
  [ATTRIBUTE.WHEN_MADE]: 'When was it made?',
  [ATTRIBUTE.WHO_MADE]: 'Who made it?',
  [ATTRIBUTE.WIDTH]: 'Width',
  CENTS: '¢',
  FIND: 'Find',
  PROFILE: 'Choose Profile',
  REPLACE: 'Replace',
  SCALE: 'Choose Scale',
  UNIT: 'Choose a unit',
};

export const TAG = {
  DELETE: 'delete',
  ERROR,
  NEW,
  PRODUCT: 'product',
  READONLY: 'readonly',
};

export const FORM = {
  DESCRIPTION: ATTRIBUTE.DESCRIPTION,
  DETAILS: 'details',
  FILES: ATTRIBUTE.FILES,
  INVENTORY: 'inventory',
  PERSONALIZATION: ATTRIBUTE.PERSONALIZATION,
  PHOTOS: ATTRIBUTE.PHOTOS,
  VIDEOS: ATTRIBUTE.VIDEOS,
  PRICING: 'pricing',
  SEO: ATTRIBUTE.SEO,
  SHIPPING: ATTRIBUTE.SHIPPING,
  TAGS: ATTRIBUTE.TAGS,
  TITLE: ATTRIBUTE.TITLE,
  VARIATIONS: ATTRIBUTE.VARIATIONS,
};

export const FORMS = [
  FORM.PHOTOS,
  FORM.VIDEOS,
  FORM.TITLE,
  FORM.DESCRIPTION,
  FORM.TAGS,
  FORM.DETAILS,
  FORM.PRICING,
  FORM.INVENTORY,
  FORM.VARIATIONS,
  FORM.PERSONALIZATION,
  FORM.SHIPPING,
  FORM.FILES,
  FORM.SEO,
];

export const FORMS_WITH_VELA_TAB = Set([
  FORM.PHOTOS,
  FORM.TITLE,
  FORM.DESCRIPTION,
  FORM.INVENTORY,
  FORM.PRICING,
  FORM.TAGS,
  FORM.VARIATIONS,
]);

export const FORM_TITLE = {
  [FORM.DESCRIPTION]: 'Description',
  [FORM.DETAILS]: 'Details',
  [FORM.FILES]: 'Digital files',
  [FORM.INVENTORY]: 'Inventory',
  [FORM.PERSONALIZATION]: 'Personalization',
  [FORM.PHOTOS]: 'Photos',
  [FORM.VIDEOS]: 'Video',
  [FORM.PRICING]: 'Price',
  [FORM.SHIPPING]: 'Shipping',
  [FORM.TAGS]: 'Tags',
  [FORM.TITLE]: 'Title',
  [FORM.VARIATIONS]: 'Variations',
  [FORM.SEO]: 'Search engine listing',
};
